import React from 'react';

export const ErrorCard = props => {
  return (
    <div className="card shadow background-blur with-icon errorToDoLoad">
      <span className="errorMSG">{props.message}</span>
    </div>
  );
};
